import { UseFeatureTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/useFeature.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";
import { ReviewsSearchStort } from "@/types/service/reviews/reviews.api";

export const getBazaarvoiceFeatureUsed = (
    data: TypedAnalyticsEvent<UseFeatureTrackingInfo>
): BV.FeatureUsedData | undefined => {
    const eventData = data.payload.eventData;

    const baseFeatureUsedData = {
        bvProduct: "RatingsAndReviews",
        productId: eventData.sku,
        type: "Used" as const,
        brand: eventData.brand,
        categoryId: eventData.categoryId
    } as const satisfies Readonly<Partial<BV.FeatureUsedData>>;

    switch (eventData.name) {
        case "helpfulness":
            return {
                ...baseFeatureUsedData,
                name: "helpfulness",
                detail1: eventData.vote
            };
        case "sort":
            return {
                ...baseFeatureUsedData,
                name: "sort",
                detail1: (
                    {
                        [ReviewsSearchStort.MOST_RELEVANT]: "relevancy",
                        [ReviewsSearchStort.MOST_HELPFUL]: "mostHelpful",
                        [ReviewsSearchStort.SCORE_DESC]: "positive",
                        [ReviewsSearchStort.SCORE_ASC]: "negative",
                        [ReviewsSearchStort.MOST_RECENT]: "mostRecent"
                    } as const
                )[eventData.direction]
            };
        case "stars":
            return {
                ...baseFeatureUsedData,
                name: "filter",
                detail1: "stars",
                detail2: eventData.filter
            };
        case "paginate":
            return {
                ...baseFeatureUsedData,
                name: "paginate",
                detail1: eventData.page
            };
        case "link":
            return {
                ...baseFeatureUsedData,
                name: "link",
                detail1: eventData.linkType
            };
        case "write":
            return {
                ...baseFeatureUsedData,
                name: "write",
                detail1: "review"
            };
        case "submit":
            return {
                ...baseFeatureUsedData,
                name: "submit",
                detail1: "review"
            };
        case "profile":
            return {
                ...baseFeatureUsedData,
                name: "profile"
            };
        case "statistics":
            return {
                ...baseFeatureUsedData,
                name: "statistics"
            };
        case "expand":
            return {
                ...baseFeatureUsedData,
                name: "expand"
            };
        case "report":
            return {
                ...baseFeatureUsedData,
                name: "report"
            };
    }
};
